export default __webpack_public_path__ + "static/white-logo-92babb65b60ee9013d96ecb77075e550.png";